// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .north-arrow {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
  }
  
  .legend-placeholder {
    position: absolute;
    bottom: 20px;
    left: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 5px;
    border: 1px solid #000;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Views/LandInfraDevelopment/GISView/Forms/jic print map/Print-Styling.css"],"names":[],"mappings":"EAAE;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,YAAY;IACZ,sBAAsB;EACxB","sourcesContent":["  .north-arrow {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .legend-placeholder {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    left: 10px;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    padding: 5px;\r\n    border: 1px solid #000;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
